import React from 'react';
// Data
import { testimonialsArray } from '../../utils/data/ReviewData';

function TestimonialSection() {
  return (
    <section
      id='testimonials'
      className='px-6 mb-16 sm:px-16 lg:px-20 max-w-3xl lg:max-w-7xl mx-auto text-center'
    >
      <h2 className='text-3xl lg:text-6xl bg-colour5 shadow-cardShadowBold shadow-colour4/50 font-titleFont'>Testimonials</h2>
      <div className='grid gap-6 mt-6 lg:grid-cols-3'>
        {testimonialsArray.map((testimonial, index) => (
          <article
            key={index}
            className='grid px-4 py-6 border bg-colour4 shadow-cardShadowBold shadow-colour4/80'
          >
            <section>
              <h6 className='text-xl font-bold font-newsweekly uppercase'>
                {testimonial.name}
              </h6>
              <div className='px-4'>
                <p className='text-sm opacity-75'>{testimonial.date}</p>
                <p className='mt-2 italic'>{testimonial.review}</p>
              </div>
            </section>
            <div className='pt-3 neon_text text-colour2'>{'★★★★★'}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TestimonialSection;
